import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    CircularProgress,
    Stack,
    Typography
} from "@mui/material";
import AppleIcon from '@mui/icons-material/Apple';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LinuxIcon } from "../../icons/LinuxIcon";
import { MicrosoftIcon } from "../../icons/MicrosoftIcon";

type Props = {urls: {
        mac: string;
        debian: string;
        redhat: string;}
    , isLoading: boolean;}

const DownloadClient = ({ urls, isLoading }:Props) => {


    return (
        <Stack>
            {isLoading &&
                <CircularProgress size={100} sx={{ width: "250px", height: "250px" }} />
            }

            {!isLoading &&
                <Stack gap={4}>
                    <Typography variant="h1" fontWeight="600" fontSize="18px">
                        Installed on your local machine, the download client allows you to manage all your transfers from the platform in one streamline tool.
                    </Typography>

                    <Stack flexDirection="row" gap={4}>
                        <a href={urls.mac} download>
                            <Button variant="secondary" startIcon={<AppleIcon/>}>
                                Download for Mac
                            </Button>
                        </a>


                        <Button variant="secondary" startIcon={<MicrosoftIcon/>}>
                            Download for Windows
                        </Button>

                        <a href={urls.redhat} download>
                            <Button variant="secondary" startIcon={<LinuxIcon/>}>
                                Download for Linux (Red hat)
                            </Button>
                        </a>

                        <a href={urls.debian} download>
                            <Button variant="secondary" startIcon={<LinuxIcon/>}>
                                Download for Linux (Debian)
                            </Button>
                        </a>
                    </Stack>


                    {//TODO:
                        //Implement the proper steps for the download client covered by ticket LC-1541
                    }

                    <Typography variant="h1" fontWeight="600" fontSize="16px">
                        Follow the steps below to setup and connect your download clients
                    </Typography>

                    <Stack gap={2}>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="600">1. Install the download client:</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack gap={4}>
                                    <Typography>1.1 Download the download client using one of above options.</Typography>
                                    <Typography>1.2 Install the download client on your computer.</Typography>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="600">2. Login:</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack gap={4}>
                                    <Typography>2.1 Open the download client.</Typography>
                                    <Typography>2.2 Click on <b>Login</b>.</Typography>
                                    <Typography>2.3 You will be redirected to Lasso web portal, click <b>Globus</b> to login.</Typography>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="600">3. Specify directory for file transfer:</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack gap={4}>
                                    <Typography>3.1 Enter a name on the input field to name your download client and click on <b>Submit</b>.</Typography>
                                    <Typography>3.2 Click on the Settings button on top right corner.</Typography>
                                    <Typography>3.3 Select a directory and then click on <b>Confirm</b>.</Typography>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="600">4. Trigger a transfer:</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack gap={4}>
                                    <Typography>4.1 After the Download Client has been successfully downloaded and installed, go back to the application and navigate to <b>Query Data</b>.</Typography>
                                    <Typography>4.2 Click on <b>Choose Files for Download</b>.</Typography>
                                    <Typography>4.3 Select the files you want to download and click on <b>Trigger Transfer</b>.</Typography>
                                    <Typography>4.4 Select the option <b>Lasso Download Client</b>.</Typography>
                                    <Typography>4.5 Select the download client you registered and click on <b>Transfer</b>.</Typography>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>
                    </Stack>

                </Stack>}
        </Stack>

    )


}

export default DownloadClient